import { computed, get } from '@ember/object';
import emailValidator from '@intercom/pulse/lib/email-validator';

export default function isValidEmail(dependentKey) {
  return computed(dependentKey, function () {
    let email = get(this, dependentKey);
    return emailValidator(email);
  });
}
